var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMattressType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81702 7.18701H4.93802C5.45902 7.18701 5.88102 7.60901 5.88102 8.13001C5.88102 8.65101 5.45902 9.07301 4.93802 9.07301H1.81702C1.29602 9.07301 0.874023 8.65101 0.874023 8.13001C0.874023 7.61001 1.29602 7.18701 1.81702 7.18701Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.984 7.18701H14.105C14.626 7.18701 15.048 7.60901 15.048 8.13001C15.048 8.65101 14.626 9.07301 14.105 9.07301H10.984C10.463 9.07301 10.041 8.65101 10.041 8.13001C10.041 7.61001 10.463 7.18701 10.984 7.18701Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.099 7.18701H6.823C6.303 7.18701 5.88 7.61001 5.88 8.13001C5.88 8.65101 6.302 9.07301 6.823 9.07301H9.099C9.62 9.07301 10.042 8.65101 10.042 8.13001C10.041 7.61001 9.619 7.18701 9.099 7.18701Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMattressType);
export default __webpack_public_path__ + "static/media/mattress_type.092ad3d8.svg";
export { ForwardRef as ReactComponent };